import React, { useState, useEffect } from 'react'
import { Alert } from 'react-bootstrap'
import '../../components/kyc/kycStyle.css'
import { validateIdNumber } from '../../utils/Validation'
import {
  DEEDS_OFFICE_PERSON_OPTIONS,
  INVALID_ID_WARNING,
} from '../../utils/Constants'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import ScreenHeader from '../../components/kyc/ScreenHeader'
import CheckboxSelect from '../../components/form/CheckboxSelect/CheckboxSelect'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import FormInput from '../../components/form/FormInput/FormInput'

interface Props {
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
  initialState: any
  setInitialState: React.Dispatch<React.SetStateAction<any>>
}

export const DeedsOfficePerson: React.FC<Props> = ({
  setShow,
  setIsError,
  setErrorMessage,
  initialState,
  setInitialState,
}) => {
  const defaultCost = 32
  const [showProgress, setShowProgress] = useState(false)
  const [searchBySelectedOption, setSearchBySelectedOption] = useState(
    DEEDS_OFFICE_PERSON_OPTIONS.searchBy[0].value,
  )
  const [totalCost, setTotalCost] = useState(0)
  const [isChecked, setIsChecked] = useState(false)
  const [offices, setOffices] = useState(DEEDS_OFFICE_PERSON_OPTIONS.offices)
  const [surname, setSurname] = useState('')
  const [forenames, setForenames] = useState('')
  const [initials, setInitials] = useState('')
  const [idNumber, setIdNumber] = useState('')
  const [reference, setReference] = useState('')
  const [companyTrustName, setCompanyTrustName] = useState('')
  const [registrationNumber, setRegistrationNumber] = useState('')

  const [isDisabled, setIsDisabled] = useState(true)

  const handleChange = (id: string) => {
    const checkedOfficeId = parseInt(id)
    const updatedOffices = offices.map((office) => {
      if (parseInt(office.id) === checkedOfficeId) {
        return { ...office, checked: !office.checked }
      }
      return office
    })
    setOffices(updatedOffices)

    const checkedOffices = updatedOffices.filter((office) => office.checked)
    const newTotalCost = checkedOffices.reduce(
      (acc, office) => acc + defaultCost,
      0,
    )
    setTotalCost(newTotalCost)

    setIsChecked(checkedOffices.length > 0)
  }
  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      deedsOfficeSearch: {
        searchBySelectedOption: searchBySelectedOption,
        totalCost: totalCost,
        surname: surname,
        forenames: forenames,
        initials: initials,
        idNumber: idNumber,
        reference: reference,
        companyTrustName: companyTrustName,
        registrationNumber: registrationNumber,
      },
    })
  }
  const handleSearch = () => {
    updateInitialState()
    //add search logic here
  }

  const validateFields = () => {
    if (searchBySelectedOption === 'INDIVIDUAL') {
      if (!forenames || !surname) {
        if (validateIdNumber(idNumber)) {
          setIsDisabled(false)
        } else {
          setIsDisabled(true)
        }
      } else if (forenames && surname) {
        setIsDisabled(false)
      }
    }
    if (searchBySelectedOption === 'COMPANY') {
      if (!companyTrustName || !registrationNumber || !isChecked) {
        setIsDisabled(true)
      }
    }
  }
  useEffect(() => {
    validateFields()
  }, [
    idNumber,
    isChecked,
    companyTrustName,
    registrationNumber,
    surname,
    forenames,
  ])

  return (
    <>
      <ScreenHeader
        price={totalCost}
        headerText="Deeds Office Person"
        subHeaderText="Search the Deeds Office for person information"
        sampleReport={'consumerreportVincent.pdf'}
      />
      <SearchBySelect
        onChangeHandler={setSearchBySelectedOption}
        options={DEEDS_OFFICE_PERSON_OPTIONS.searchBy}
      />
      <CheckboxSelect
        options={DEEDS_OFFICE_PERSON_OPTIONS.offices}
        onChange={handleChange}
        label={'Deeds Offices'}
      />

      {searchBySelectedOption === 'INDIVIDUAL' && (
        <>
          <FormInput
            autoFocus
            labelText="Id number"
            placeHolderText="Unique identity number"
            onChangeHandler={setIdNumber}
            value={idNumber}
          />

          {idNumber !== '' && !validateIdNumber(idNumber) ? (
            <Alert variant="danger" transition={false}>
              {INVALID_ID_WARNING}
            </Alert>
          ) : null}
          <FormInput
            labelText="Surname"
            placeHolderText="Enter surname"
            onChangeHandler={setSurname}
            value={surname}
          />
          <FormInput
            labelText="Forename(s)"
            placeHolderText="Enter forename(s)"
            onChangeHandler={setForenames}
            value={forenames}
          />
          <FormInput
            labelText="Initial(s)"
            placeHolderText="Enter initial(s)"
            onChangeHandler={setInitials}
            value={initials}
          />
        </>
      )}
      {searchBySelectedOption === 'COMPANY' && (
        <>
          <FormInput
            autoFocus
            required
            labelText="Company/Trust name"
            placeHolderText="Enter Company/Trust name"
            onChangeHandler={setCompanyTrustName}
            value={companyTrustName}
          />
          <FormInput
            required
            labelText="Registration number"
            placeHolderText="Enter registration number"
            onChangeHandler={setRegistrationNumber}
            value={registrationNumber}
          />
        </>
      )}
      <FormInput
        labelText="Reference"
        placeHolderText="Search reference (optional)"
        onChangeHandler={setReference}
        value={reference}
      />
      <FooterButtons
        handleSearch={handleSearch}
        isLoading={showProgress}
        setShow={setShow}
        isDisabled={isDisabled}
      />
    </>
  )
}

export default DeedsOfficePerson
